/**
 * 生成设备指纹 - 用于设备绑定识别
 * 基于浏览器特性生成相对稳定的唯一标识
 * 使用 SHA-256 hash 降低碰撞概率
 */
export async function generateFingerprint(): Promise<string> {
  try {
    const canvas = document.createElement('canvas')
    const gl = (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')) as WebGLRenderingContext | null
    let canvasHash = ''
    if (gl) {
      const vendor = gl.getParameter(gl.VENDOR)
      const renderer = gl.getParameter(gl.RENDERER)
      canvasHash = btoa(`${vendor} | ${renderer}`).slice(0, 16)
    }

    const fingerprintData = {
      l: navigator.language,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
      s: `${screen.width}x${screen.height}`,
      pr: window.devicePixelRatio,
      c: canvasHash,
      wv: gl?.getParameter(gl.VENDOR) ?? '',
      wr: gl?.getParameter(gl.RENDERER) ?? '',
    }

    // 使用 SHA-256 生成高质量 hash，取前 32 个 hex 字符（128 位）
    const json = JSON.stringify(fingerprintData)
    const encoder = new TextEncoder()
    const data = encoder.encode(json)
    const hashBuffer = await crypto.subtle.digest('SHA-256', data)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

    return hex.slice(0, 32)
  }
  catch (error) {
    console.warn('[fingerprint] 生成失败，使用 fallback:', error)
    // Fallback: 持久化到 localStorage，避免每次生成不同值导致重复绑定设备
    let fallback = localStorage.getItem('device-fingerprint-fallback')
    if (!fallback) {
      fallback = `fallback-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
      localStorage.setItem('device-fingerprint-fallback', fallback)
    }
    return fallback
  }
}
